import { render, staticRenderFns } from "./reaction-panel.vue?vue&type=template&id=312d849b"
import script from "./reaction-panel.vue?vue&type=script&lang=js"
export * from "./reaction-panel.vue?vue&type=script&lang=js"
import style0 from "./reaction-panel.vue?vue&type=style&index=0&id=312d849b&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports